import * as React from "react";
import Button, { ButtonProps } from "@material-ui/core/Button";
import styled from "styled-components";

type Props = ButtonProps & {
  paddingLeftRight?: number;
};

const StyledButton = styled(({ paddingLeftRight, ...rest }: Props) => (
  <Button {...rest} />
))`
  padding: 6px ${props => props.theme.spacing(props.paddingLeftRight ?? 4)}px;
  min-width: 0px;
  width: 200px;
  border: 1px solid transparent;
`;

export const PrimaryButton: React.FunctionComponent<Props> = props => {
  return (
    <StyledButton
      paddingLeftRight={props.paddingLeftRight}
      {...props}
      color={props.color ?? "primary"}
      variant={"contained"}
    ></StyledButton>
  );
};
